export const proyecto_config = {
    
}